import React from 'react';
import {Box, MenuItem, TextField, Typography} from '@material-ui/core';
import {EDataPointType} from './AddNewDataPointForm.constants';

interface DataPointTypeSelectorProps {
  value: EDataPointType | '';
  onChange: (value: EDataPointType | '') => void;
  disabledTypes?: EDataPointType[];
}

export const DataPointTypeSelector: React.FC<DataPointTypeSelectorProps> = ({
  value,
  onChange,
  disabledTypes = [],
}) => {
  return (
    <Box mb={3}>
      <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 8}}>
        Data point type
      </Typography>
      <TextField
        select
        fullWidth
        variant="outlined"
        size="small"
        value={value}
        onChange={(e) => onChange(e.target.value as EDataPointType | '')}
        placeholder="Select a data point type"
        InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
      >
        <MenuItem value="">
          <em>Select a data point type</em>
        </MenuItem>
        {Object.values(EDataPointType).map((type) => (
          <MenuItem
            key={type}
            value={type}
            disabled={disabledTypes.includes(type)}
          >
            {type}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
};
